<script setup>
import {computed, ref, useAttrs} from "vue";
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import AddImageButton from "../Pub/components/AddImageButton.vue";
import EditToggleButton from "../Pub/components/EditToggleButton.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    symbolPath: {
        type: String,
        required: true,
    },
    symbolHolderStyle: {
        type: String,
        default: '',
    },
    symbolName: {
        type: String,
        required: true
    },
    symbolWrapperClasses: {
        type: [String, Array, Object],
        default: ''
    },
    title: {
        type: String,
        default: 'Symbol upload'
    },
    symbolUploadUrl: {
        type: String,
        required: true
    },
    symbolDeleteUrl: {
        type: String,
        required: true
    },
});

const isEditing = ref(false);
const hoverActive = ref(false);

const emit = defineEmits(['update:symbolPath']);

const symbolSrc = computed({
    get: () => props.symbolPath,
    set: (value) => emit('update:symbolPath', value)
});

const shouldShowAddImageButton = computed(() => {
    return portalContentAndDesignStore.liveDesignerEnabled
        && !isEditing.value
        && !symbolSrc
        && props.showAddImageButton;
});

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}
</script>

<template>
<add-image-button
    v-if="shouldShowAddImageButton"
    @click="isEditing = true"
/>
<div
    v-if="symbolSrc || isEditing"
    class="relative"
    @mouseenter="hoverActive = true"
    @mouseleave="hoverActive = false"
>
    <edit-toggle-button
        v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
        :is-editing="isEditing"
        @toggle="toggleEdit"
        class="transition-opacity duration-200"
    />

    <div
        v-if="!isEditing"
        :class="symbolWrapperClasses"
        :style="`background-image: url(${symbolPath})`"
    ></div>

    <file-upload
        v-else-if="isEditing"
        v-model:src="symbolSrc"
        no_src="/images/upload-image.png"
        accept="image/*"
        :title="title"
        :name="symbolName"
        :upload_url="symbolUploadUrl"
        :delete_url="symbolDeleteUrl"
    ></file-upload>
</div>
</template>
